import { pxToNumber, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SearchBoxWithIconWrapper = styled.div`
  height: 40px;
  margin-left: auto;
  position: relative;
`

export const DynamicInputWrapper = styled.div`
  width: calc(100% + ${pxToNumber(Spacing.S8) * 2}px);
  margin: -${Spacing.S8};
  padding: ${Spacing.S8};
  overflow: hidden;
`
